import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { LoadData, PrintBill, ExportDetailData as _ExportDetailData, GetLastById, GetNextById, GetVendorEmail } from '@/api/SubDeliveryNote';
import util from '@/libs/util';
import { GetReportID as _GetReportID } from '@/api/SysReportTpl';
import { SendEmail } from '@/api/SendMail';
import ExportListMixin from '@/views/mixin/ExportList';
export default {
  mixins: [ExportListMixin],
  mounted: function mounted() {
    var _this = this;

    this.GetReportID(); // 监听点击新增明细

    this.Bus.on('onBeforeShowAddRowDialog', function () {
      _this.Bus.emit('onShowAddRowDialog', _this.formData.VENDOR_CODE);
    }); // 监听审核、反审核、作废变化
    // this.Bus.on('onUpdataOrderStaus',()=>{
    //     this.updataStatus()
    // })
  },
  data: function data() {
    return {
      formData: {
        DELIVERY_NO: null,
        // 送货单号
        CREATORID: null,
        // 制单人
        DESCRIPTION: null,
        // 备注
        DELIVERY_DATE: null,
        // 出货日期
        VENDOR_CODE: null,
        // 供应商代码
        ARRIVAL_DATE: null,
        // 到货日期
        STATUS_Caption: null // 单据状态

      },
      submitData: {},
      mode: 'show',
      templateID: null,
      userInfo: JSON.parse(util.cookies.get('userInfo'))
    };
  },
  methods: {
    // 通过ID获取单据信息
    asyncData: function asyncData(ID) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res, row;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  Page: 1,
                  // 当前页
                  Limit: 10,
                  // 分页大小
                  Data: {
                    ORGANIZE_ID: util.cookies.get('ORG_ID'),
                    ID: ID
                  }
                };
                console.log('TabelHeaderForEdit params', params);
                _context.next = 4;
                return LoadData(params);

              case 4:
                res = _context.sent;
                console.log('TabelHeaderForEdit 通过ID获取单据信息', res);

                if (res.code === 0) {
                  if (res.data.Items.length > 0) {
                    row = res.data.Items[0];

                    _this2.setData(row);
                  } else {
                    _this2.$message.warning('获取单据信息失败');
                  }
                } else {
                  _this2.$message.warning('res.message');
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleARRIVAL_DATE: function handleARRIVAL_DATE(v) {
      // console.log('now',new Date());
      // console.log(new Date() < v)
      if (!(new Date() < v)) {
        this.$message.warning('提醒：到货日期早于当前系统日期');
      }
    },
    // 邮件发送
    mailSend: function mailSend() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3$formData, ID, DELIVERY_NO, VENDOR, res, formData, emailParams, key;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3$formData = _this3.formData, ID = _this3$formData.ID, DELIVERY_NO = _this3$formData.DELIVERY_NO, VENDOR = _this3$formData.VENDOR;
                _context2.next = 3;
                return GetVendorEmail({
                  mst_id: ID
                });

              case 3:
                res = _context2.sent;

                if (res.code === 0) {
                  formData = new FormData();
                  emailParams = {
                    Recipient: res.data,
                    MailTitle: "".concat(DELIVERY_NO),
                    MailBody: "".concat(VENDOR, " ").concat(DELIVERY_NO, " <br/> ").concat(window.location.href, " <br/><br/> SCM"),
                    ORGANIZE_ID: util.cookies.get('ORG_ID')
                  };

                  for (key in emailParams) {
                    formData.append(key, emailParams[key]);
                  }

                  SendEmail(formData).then(function (emailRes) {
                    _this3.$closeLoading();

                    if (emailRes.code === 0) {
                      _this3.$message.success('邮件发送成功');
                    } else {
                      _this3.$message.error(emailRes.message);
                    }
                  }).catch(function (err) {
                    _this3.$closeLoading();

                    _this3.$message.error(err);
                  });
                } else {
                  _this3.$message.error(res.message);
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 导出明细
    ExportDetailData: function ExportDetailData() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var ID, ORGANIZE_ID, EXPORT_FILE_NAME;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // console.log('this.submitData', this.submitData)
                ID = _this4.submitData.ID;
                ORGANIZE_ID = util.cookies.get('ORG_ID');
                EXPORT_FILE_NAME = '下游送货单明细';

                _this4.$message.success('已添加到 导出列表 中');

                _this4.setUnreadExportMessionNum();

                _ExportDetailData({
                  ID: ID,
                  ORGANIZE_ID: ORGANIZE_ID,
                  EXPORT_FILE_NAME: EXPORT_FILE_NAME
                });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 修改单据保存
    handleSave: function handleSave() {
      // console.log('修改保存');
      // console.log('出货日期', new Date(Date.parse(this.formData.DELIVERY_DATE)));
      // console.log('到货日期',Date.parse(this.formData.ARRIVAL_DATE) );
      if (Date.parse(this.formData.ARRIVAL_DATE) < Date.parse(this.formData.DELIVERY_DATE)) {
        this.$message.warning('到货日期不能少于出货日期');
      } else {
        // console.log('this.formData',this.formData);
        // console.log(new Date(Date.parse(this.formData.DELIVERY_DATE)));
        // console.log('this.submitData',this.submitData);
        // this.submitData.DELIVERY_DATE = new Date(Date.parse(this.formData.DELIVERY_DATE))
        // this.submitData.ARRIVAL_DATE = new Date(Date.parse(this.formData.ARRIVAL_DATE))
        this.submitData.DELIVERY_DATE = this.formData.DELIVERY_DATE;
        this.submitData.ARRIVAL_DATE = this.formData.ARRIVAL_DATE; // console.log(this.formData.DELIVERY_DATE);
        // console.log(this.formData.ARRIVAL_DATE);
        // this.Bus.emit('onBeforeSaveEditOrder',this.submitData)

        this.$emit('onBeforeSaveEditOrder', this.submitData);
      }
    },
    // 设置数据
    setData: function setData(data) {
      this.formData.DELIVERY_NO = data.DELIVERY_NO;
      this.formData.CREATORID = data.CREATORID;
      this.formData.DESCRIPTION = data.DESCRIPTION;
      this.formData.DELIVERY_DATE = util.formatTime.transCommDate(data.DELIVERY_DATE);
      this.formData.VENDOR = data.VENDOR_NAME;
      this.formData.ARRIVAL_DATE = util.formatTime.transCommDate(data.ARRIVAL_DATE);
      this.formData.STATUS_Caption = data.STATUS_Caption;
      this.formData.VENDOR_CODE = data.VENDOR_CODE;
      this.formData.ID = data.ID;
      this.submitData = JSON.parse(JSON.stringify(data));
    },
    handleDay: function handleDay(v) {
      // console.log(v)
      if (!(new Date() < v)) {
        this.$message.warning('提醒：出货日期早于当前系统日期');
      }
    },
    // 上一张单据更新数据
    getBackUpdata: function getBackUpdata() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log(_this5.formData);
                params = {
                  mst_id: _this5.formData.ID,
                  organize_id: util.cookies.get('ORG_ID')
                };
                _context4.next = 4;
                return GetNextById(params);

              case 4:
                res = _context4.sent;
                console.log('上一张res', res);

                if (res.code === 0) {
                  if (res.data) {
                    _this5.setData(res.data);

                    _this5.$emit('cbNextOrder', res.data.ID, res.data.STATUS);
                  } else {
                    _this5.$message.warning('当前单据已为最前单据');
                  }
                } else {
                  _this5.$message.warning('切换上一张单据失败');
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 下一张单据更新数据
    nextOrderUpdata: function nextOrderUpdata() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log(_this6.formData);
                params = {
                  mst_id: _this6.formData.ID,
                  organize_id: util.cookies.get('ORG_ID')
                };
                _context5.next = 4;
                return GetLastById(params);

              case 4:
                res = _context5.sent;
                console.log(res);

                if (res.code === 0) {
                  if (res.data) {
                    _this6.setData(res.data);

                    _this6.$emit('cbNextOrder', res.data.ID, res.data.STATUS);
                  } else {
                    _this6.$message.warning('当前单据已为最后单据');
                  }
                } else {
                  _this6.$message.warning('切换下一张单据失败');
                }

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 打印单据
    PrintOrder: function PrintOrder() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var params, res, token, dataurl, dxurl, url;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this7.templateID) {
                  _context6.next = 3;
                  break;
                }

                _this7.$message({
                  showClose: true,
                  message: _this7.$t('找不到条码打印模板！'),
                  type: 'warning'
                });

                return _context6.abrupt("return");

              case 3:
                params = {
                  id: _this7.submitData.ID,
                  orG_CODE: util.cookies.get('ORG_CODE'),
                  organizE_ID: util.cookies.get('ORG_ID'),
                  operator: _this7.userInfo.USER_NAME
                };
                _context6.next = 6;
                return PrintBill(params);

              case 6:
                res = _context6.sent;

                if (res.code === 0) {
                  _this7.updataStatus(); // console.log('点击打印');
                  // console.log(this.submitData.ID);


                  token = util.cookies.get('token');
                  dataurl = process.env.VUE_APP_API + "/DeliveryNote/GetBillRptDataByID?mst_id=".concat(_this7.submitData.ID);
                  dxurl = _this7.$store.getters.getVUE_APP_PRINT_TPL + 'Home/PreviewReport';
                  url = "".concat(dxurl, "?DATA_URL=").concat(dataurl, "&REPORT_ID=").concat(_this7.templateID, "&Token=").concat(token); // console.log(url);

                  util.open(url);
                } else {
                  _this7.$message.warning('打印失败');
                }

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 获取打印模板id
    GetReportID: function GetReportID() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                params = {
                  billtype: 'scmDn'
                };
                _context7.next = 3;
                return _GetReportID(params);

              case 3:
                res = _context7.sent;
                console.log('模板id', res);

                if (res.code === 0) {
                  _this8.templateID = res.data;
                } else {
                  _this8.$message.warning('获取打印模板失败');
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 更新表头
    updataStatus: function updataStatus(id) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log('更新表头', id);
                params = {
                  Page: 1,
                  // 当前页
                  Limit: 10,
                  // 分页大小
                  Data: {
                    ORGANIZE_ID: util.cookies.get('ORG_ID'),
                    DELIVERY_NO: id || _this9.formData.DELIVERY_NO
                  }
                };
                _context8.next = 4;
                return LoadData(params);

              case 4:
                res = _context8.sent;

                if (res.code === 0) {
                  _this9.formData.DELIVERY_NO = res.data.Items[0].DELIVERY_NO;
                  _this9.formData.CREATORID = res.data.Items[0].CREATORID;
                  _this9.formData.DESCRIPTION = res.data.Items[0].DESCRIPTION;
                  _this9.formData.VENDOR = res.data.Items[0].VENDOR_NAME; // this.formData.DELIVERY_DATE = res.data.Items[0].DELIVERY_DATE
                  // this.formData.ARRIVAL_DATE = res.data.Items[0].ARRIVAL_DATE

                  _this9.formData.DELIVERY_DATE = util.formatTime.transCommDate(res.data.Items[0].DELIVERY_DATE);
                  _this9.formData.ARRIVAL_DATE = util.formatTime.transCommDate(res.data.Items[0].ARRIVAL_DATE);
                  _this9.formData.STATUS_Caption = res.data.Items[0].STATUS_Caption;
                  _this9.formData.VENDOR_CODE = res.data.Items[0].VENDOR_CODE;
                  _this9.submitData = JSON.parse(JSON.stringify(res.data.Items[0]));
                }

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 点击供应商input
    handleVendorInput: function handleVendorInput() {}
  },
  watch: {
    $SubDeliveryNoteState: {
      handler: function handler(nawValue) {
        // console.log('表头 单据操作状态 MaintainDeliveryNote2OrderState==>',nawValue);
        if (nawValue === 'orderShow') {
          this.mode = 'show'; // this.getOrderData()
        } else if (nawValue === 'listShow') {
          for (var key in this.formData) {
            this.formData[key] = null;
          }
        } else {
          this.mode = 'edit';
        }
      },
      immediate: true
    }
  },
  computed: {// ...mapGetters(['OutsourcedState'])
  },
  beforeDestroy: function beforeDestroy() {}
};